const GoogleApiKey = {
    production: process.env.REACT_APP_GOOGLE_KEY,
    development:  process.env.REACT_APP_GOOGLE_KEY_DEV
}

export default GoogleApiKey;
